import React from 'react';

// Mobx
import { inject, observer } from 'mobx-react';

// Icons
import 'font-awesome/css/font-awesome.min.css';

// Navigation
import { useNavigate, Navigate, Link } from 'react-router-dom';

// Helpers
import Helpers from '../../helpers';

// Css
import '../../assets/css/app.css';

// Layout
import CommerceLayout from '../layouts/CommerceLayout';

// Components
import LoginForm from '../../components/LoginForm';
import FunctionalButton from '../../components/Buttons/FunctionalButton';

@inject('AuthStore', 'ShoppingCartStore')
@observer
class Profile extends React.Component<any> {
    constructor(props: any) {
        super(props);
    }

    render() {
        const storeId: any = localStorage.getItem('storeId');

        return (
            storeId !== null ?
                <CommerceLayout
                    title={Helpers.translation('my_shopping_cart')}
                    visibleCategories={false}
                >
                    <section id="breadcrumbs" className="pt-6 bg-gray-50">
                        <div className="container mx-auto px-4 text-xs md:text-base">
                            <ol className="list-reset flex">
                                <li>
                                    <Link
                                        className="font-semibold hover:text-primary"
                                        to={`/home`}
                                    >
                                        {Helpers.translation('home')}
                                    </Link>
                                </li>
                                <li>
                                    <span className="mx-2">&gt;</span>
                                </li>
                                <li>{Helpers.translation('profile')}</li>
                            </ol>
                        </div>
                    </section>

                    {
                        this.props.AuthStore.userData.isLogin ?
                            <section id="shop">
                                <div className="container mx-auto p-4">
                                    <div className="flex flex-col">
                                        <div className="w-full">
                                            <div className="flex flex-wrap">
                                                <Link to="/profile/personal">
                                                    <FunctionalButton
                                                        text={Helpers.translation('personal_settings')}
                                                        rounded
                                                        customClasses="mb-2"
                                                    />
                                                </Link>

                                                <Link to="/profile/password">
                                                    <FunctionalButton
                                                        text={Helpers.translation('password_settings')}
                                                        rounded
                                                        customClasses="mb-2 ml-2"
                                                    />
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>
                            :
                            <LoginForm
                                message={Helpers.translation('you_need_login_for_view_this_page')}
                            />
                    }
                </CommerceLayout>
                :
                <Navigate to="/" replace={true} />
        )
    }
}

function WithNavigate(props: any) {
    let navigate = useNavigate();
    return <Profile {...props} navigate={navigate} />
}

export default WithNavigate;